<template lang="pug">
    .admin-localization
        h2.content-block {{ $tCaption('Administration: Localization') }}
        .content-block
            .dx-card.responsive-paddings
                .admin-localization.flex-row
                    dx-data-grid.data-grid(
                        ref="grid"
                        :root-value="0"
                        :data-source="categories"
                        :show-borders="true"
                        :word-wrap-enabled="true"
                        :column-auto-width="true"
                        :allow-column-reordering="true"
                        :allow-column-resizing="true"
                        key-expr="key"
                        :selected-row-keys="selectedCategories"
                        :auto-expand-all="true"
                        :hover-state-enabled="true"
                        :focused-row-enabled="true"
                        :grouping="{ autoExpandAll: false }",
                        @saving="updateTranslations"
                        @toolbar-preparing="onToolbarPreparing"
                        :height="listHeight || '100%'"
                    )
                        dx-column(:fixed="true", data-field="categoryCaption", :caption="$tCaption('Category')", :allowEditing="false" :min-width="50", :groupIndex="0", groupCellTemplate="groupCellTemplate", :sortIndex="0")
                        dx-column(:fixed="true", data-field="caption", :caption="$tCaption('Default')", :allowEditing="false" :min-width="50", :sortIndex="0")
                        dx-column(v-for="(column, i) in langColumns" :key="i" :data-field="column.id", :caption="column.label" :min-width="50")
                        dx-column-fixing(:enabled="true")

                        dx-scrolling(mode="standard")
                        dx-filter-row(:visible="true")
                        dx-search-panel(:visible="true" :highlight-search-text="true" :search-visible-columns-only="true")
                        dx-selection(mode="none")
                        dx-editing(
                            :fixed="true"
                            mode="batch"
                            :allow-updating="true"
                        )
                        dx-paging(:enabled="true" :page-size="50")
                        dx-pager(
                            :enabled="true"
                            :page-size="50"
                            :page-index="0"
                            :show-page-size-selector="true"
                            :allowed-page-sizes="[25, 50, 100, 250]"
                            :show-navigation-buttons="true"
                            :show-info="true"
                            info-text="Page #{0} of {1} ({2} items)"
                        )
                        template(v-slot:groupCellTemplate="{ data }")
                            span {{data.displayValue}}
        dx-popup(
            :visible.sync="isPopupVisible"
            :drag-enabled="false"
            :close-on-outside-click="true"
            :show-title="true"
            :title="$tCaption('Add a Locale')"
            :width="350"
            :height="215"
            maxWidth="90%",
            maxHeight="90%"
        )
            .flex-col.space.full-height
                .flex-row(style="flex-grow: 1")
                    language-select-box(
                        :value.sync="selectedLocale"
                        :search-enabled="true"
                        :placeholder="$tCaption('Select a locale to add')"
                        :value-expr="(item) => item"
                        display-expr="english_name"
                        search-mode="contains"
                        :search-expr="['code', 'name', 'english_name']"
                        :search-timeout="200"
                        :min-search-length="0"
                        :show-data-before-search="true",
                    )
                        template(#item="{data}")
                            span(:title="`${data.code}: ${data.english_name} / ${data.name}`") {{data.code}}: {{data.english_name}} / {{data.name}}
                .flex-row.justify
                    .left
                    .right.flex-row.space
                        dx-button(:text="$tCaption('Add')", type="default", :disabled="!canAddLocale" @click="addlocale")

</template>

<script>
    import {
        DxDataGrid,
        DxColumn,
        DxColumnFixing,
        DxSearchPanel,
        DxFilterRow,
        DxSelection,
        DxEditing,
        DxRowDragging,
        DxScrolling, DxPager, DxPaging,
    } from 'devextreme-vue/data-grid';
    import {DxPopup} from 'devextreme-vue/popup';
    import {DxButton} from 'devextreme-vue/button';
    import Data from 'app-core/Data';
    import LanguageSelectBox from "@/components/LanguageSelectBox";
    import _ from "lodash";

    export default {
		translationCategory: 'admin.localization.index',
        name: "admin-localization",
        components: {
            LanguageSelectBox,
            DxDataGrid,
            DxColumn,
            DxColumnFixing,
            DxSearchPanel,
            DxFilterRow,
            DxSelection,
            DxEditing,
            DxRowDragging,
            DxScrolling, DxPager, DxPaging,
            DxPopup,
            DxButton,
        },
        data() {
            return {
                selectedLocale: {},
                selectedCategories: [],
                categories: [],
                isPopupVisible: false,
            };
        },
        computed: {
            listHeight() {
                const mainAppHeaderHeight = 76, pageHerderHeight = 45 + 2 * 20, cardPaddings = 2 * 40,
                    bottomPadding = 20;
                return Math.min(960, window.innerHeight - mainAppHeaderHeight - pageHerderHeight - cardPaddings - bottomPadding);
            },
            canAddLocale() {
                return !_.isEmpty(this.selectedLocale)
            },
            langColumns() {
                return this.$locale.state.availableLocales/*.filter(locale => locale.code !== 'en-EN')*/;
            },
        },
        async mounted() {
            if (__DEBUG__)
                window.localizationTool = this;
            this.rebuildCategories();
        },
        methods: {
            async rebuildCategories() {
                const storedTranslations = await Data.getTranslations();
                const defultTranslateStruct = this.$locale.actions.getDefaultLocaleTranslations();
                const defaultTranslations = defultTranslateStruct.tokens;

                defaultTranslations.forEach(defaultItem => {
                    storedTranslations
                        .filter(storedItem => storedItem.key === defaultItem.key)
                        .forEach(storedItem => defaultItem[storedItem.localeId] = storedItem.translation);
                    const category = defultTranslateStruct.categories[defaultItem.category];
                    defaultItem.categoryCaption = category && category.caption || defaultItem.category;
                })

                this.categories = defaultTranslations;
            },
            addlocale() {
                Data.addLocale(this.selectedLocale).then(r => {
                    if (r.Success) {
                        this.$notifySuccess(`Locale ${r.Data.Code} added successfully`);
                    } else {
                        this.$notifyError(r.ErrorMessage);
                    }
                    this.$locale.actions.getAvailableLocales(true);
                }).finally(() => {
                    this.isPopupVisible = false;
                });
            },
            onToolbarPreparing(e) {
                let toolbarItems = e.toolbarOptions.items;
                toolbarItems.push({
                    html: `<span class="font-large">${this.$tCaption('Locales')}</span>`,
                    location: 'before'
                });
                toolbarItems.push({
                    widget: 'dxButton',
                    options: {
                        icon: 'variable',
                        text: this.$tCaption('New'),
                        hint: this.$tCaption('Add a new Locale'),
                        onClick: () => {
                            this.selectedLocale = {};
                            this.isPopupVisible = true;
                        }
                    },
                    location: 'before'
                });

                toolbarItems.push({
                    widget: 'dxButton',
                    options: {
                        icon: 'chevrondown',
                        text: this.$tCaption('Expand'),
                        hint: this.$tCaption('Expand translation categories'),
                        onClick: () => {
                            this.$refs.grid.instance.expandAll();
                        }
                    },
                    location: 'before'
                });

                toolbarItems.push({
                    widget: 'dxButton',
                    options: {
                        icon: 'chevronnext',
                        text: this.$tCaption('Collapse'),
                        hint: this.$tCaption('Collapse translation categories'),
                        onClick: () => {
                            this.$refs.grid.instance.collapseAll();
                        }
                    },
                    location: 'before'
                });
            },
            updateTranslations(v) {
                const update = [];
                const remove = [];
                v.changes.forEach(row => {
                    const translations = _.omit({...row.data}, ['key', 'category', 'caption'])
                    Object.keys(translations).forEach(key => {
                        const category = _.find(this.categories, {key: row.key})?.category;
                        if (translations[key]) {
                            update.push({LocaleOid: key, Key: row.key, Category: category, Translation: translations[key]})
                        } else {
                            remove.push({LocaleOid: key, Key: row.key})
                        }
                        this.$locale.actions.changeStoredTranslation({ key: row.key, localeId: key, translation: translations[key] });
                    })
                });

                this.$locale.actions.refreshI18n();

                if (remove.length) {
                    Data.deleteTranslations(remove);
                }
                if (update.length) {
                    Data.updateTranslations(update);
                }
            },
        },
    }
</script>

<style lang="scss">
    .admin-localization {
        .data-grid {
            min-height: 500px;
        }
    }
</style>
